// Imageresizer.js

import { useState } from 'react';
import Cropper from 'react-easy-crop'
import CropIcon from '@mui/icons-material/Crop';
import getCroppedImg from './cropImage';
// import './ImageResizer.css';

const aspectRatios = [
    { value: 3 / 2, text: "3:2" },  
    { value: 4 / 3, text: "4:3" },
    { value: 16 / 9, text: "16:9" },
    { value: 1 / 2, text: "1:2" },
    { value: 1 / 1, text: "1:1" },
    { value: 2 / 1, text: "2:1" },  
    { value: 9 / 16, text: "9:16" },
    { value: 3 / 4, text: "3:4" },
    { value: 2 / 3, text: "2:3" },
];

const ImageResizer = () => {
    const [image, setImage] = useState(null);
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [percentage, setPercentage] = useState('');
    const [quality, setQuality] = useState(80);
    const [dimensions, setDimensions] = useState({ height: 0, width: 0, size: 0 });
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedArea, setCroppedArea] = useState(null)

    const [croppedImage, setCroppedImage] = useState(null)
    const [rotation, setRotation] = useState(0)
    const [aspect, setAspect] = useState(3 / 2)
    const [mimeType, setMimeType] = useState('');
    const [filename, setFilename] = useState('');

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
        setCroppedArea(croppedArea)
        // console.log(croppedArea, croppedAreaPixels)
    }

    const cropImage = async () => {
        // setLoading(true);
        try {
        //   const { file, url } = await getCroppedImg(
            const compressedDataUrl = await getCroppedImg(
            image,
            croppedAreaPixels,
            rotation,
            mimeType
          );
        //   setImage(url);
        //   setFile(file);
          setImage(compressedDataUrl);
        //   setOpenCrop(false);
        } catch (error) {
        //   setAlert({
        //     isAlert: true,
        //     severity: 'error',
        //     message: error.message,
        //     timeout: 5000,
        //     location: 'modal',
        //   });
          console.log(error);
        }
    
        // setLoading(false);
      };
    const onAspectChange = (e) => {
        const value = e.target.value;
        // const ratio = aspectRatios.find((ratio) => ratio.value == value);
        setAspect(value);
    };

    const handleImageLoad = (e) => {
        // console.log(e)
        const { naturalHeight, naturalWidth } = e;
        setDimensions( { ...dimensions, height: naturalHeight, width: naturalWidth });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setMimeType(file.type);
        setFilename(file.name);

        // console.log(file);
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
            setDimensions({...dimensions,  size: file.size});
        }
    };

    const handlePercentageChange = (value) => {
        // console.log(value);
        setPercentage(value);
        setWidth(''); 
        setHeight('');
    }

    const handleResizeAndCompress = () => {
        const img = document.createElement('img');
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            let targetWidth, targetHeight;

            if (width && height) {
                targetWidth = parseInt(width, 10);
                targetHeight = parseInt(height, 10);
            } else if (percentage) {
                targetWidth = (parseInt(
                    percentage, 10) * img.width) / 100;
                targetHeight = (parseInt(
                    percentage, 10) * img.height) / 100;
            } else {
                targetWidth = img.width;
                targetHeight = img.height;
            }

            canvas.width = targetWidth;
            canvas.height = targetHeight;

            ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

            const compressedDataUrl = canvas.toDataURL(
                mimeType, quality / 100);
            setImage(compressedDataUrl);
        };
        img.src = image;
    };

    const handleDownload = (e, value) => {
        e.preventDefault();
        // console.log(filename);
        // console.log(value);
        const link = document.createElement('a');
        link.href = image;
        if(value==='PNG')
            link.download = 'compressed.png';
        else
            link.download = 'compressed.jpg';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // window.location.reload(); 
    };

    return (
        <div className="text-center mt-14 p-5 mx-auto max-w-2xl border bg-slate-300 rounded-md">
            <h1 className="mb-5">
                Image Resizer and Compressor
            </h1>

            <div className="mb-5">
                <label htmlFor="imageInput"
                    className="inline-block px-2 py-1 cursor-pointer font-bold text-blue-500 rounded-md border-2 border-blue-500 hover:text-teal-500  hover:border-teal-500">
                    {/* <i className="fas fa-cloud-upload-alt"></i> */}
                    Upload an Image
                </label>
                <input
                    type="file"
                    id="imageInput"
                    accept="image/*"
                    className="ml-0 mt-2 sm:mt-0 sm:ml-2"
                    onChange={handleImageChange}
                />
            </div>

            {image && (
                <div id="action-form">
                <div>
                    <div  className="mt-5">
                        {/* <h2 className="mb-5">Preview:</h2> */}
                        <div className="flex flex-wrap p-2 gap-2 items-center justify-center">
                            <div className="">
                                <label htmlFor="originalWidth">originalWidth:</label>
                                <input
                                    type="number"
                                    id="originalWidth"
                                    placeholder="Width"
                                    className="ml-1 px-1 rounded-md w-20"
                                    disabled
                                    value={dimensions.width}
                                    // onChange={(e) => setWidth(e.target.value)}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="originalHeight">originalHeight:</label>
                                <input
                                    type="number"
                                    id="originalHeight"
                                    placeholder="Height"
                                    className="ml-1 px-1 rounded-md w-20"
                                    disabled
                                    value={dimensions.height}
                                    // onChange={(e) => setHeight(e.target.value)}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="Size">Size:</label>
                                <input
                                    type="number"
                                    id="Size"
                                    placeholder="Size"
                                    className="ml-1 px-1 rounded-md w-20"
                                    disabled
                                    value={dimensions.size}
                                    // onChange={(e) => setHeight(e.target.value)}
                                /> b.
                            </div>
                        </div>
                        {/* <img id="preview" src={image} alt="Preview" onLoad={handleImageLoad} /> */}
                        <div className="relative w-full h-52 bg-['#333'] sm:h-96">
                            <Cropper
                            image={image}
                            crop={crop}
                            rotation={rotation}
                            zoom={zoom}
                            aspect={aspect}
                            onZoomChange={setZoom}
                            onRotationChange={setRotation}
                            onCropChange={setCrop}
                            onCropComplete={onCropComplete}
                            onMediaLoaded={handleImageLoad}
                            //   onCropAreaChange={setCroppedArea}
                            />
                        </div>

                        <p id="image-dimensions" style={{
                            marginTop: '10px'
                        }}>
                        </p>
                    </div>
                    <div className="flex flex-row flex-wrap items-center gap-2 mt-4 p-2 rounded-md border-2 border-slate-200">
                        <div className="rounded-md bg-slate-200 p-2">
                            <label htmlFor="zoom">Zoom:</label>
                            <input
                                type="range"
                                id="zoom"
                                min={1}
                                max={3}
                                step={0.01}
                                className="ml-1 w-36 sm:w-52 align-middle"
                                value={zoom}
                                onChange={(e) => setZoom(e.target.value)}
                            />
                            <span id="quality-value" className="ml-1 font-bold">
                                {parseFloat(zoom).toFixed(2)}
                            </span>
                        </div>
                        <div>
                            <label htmlFor="aspect">Aspect:</label>
                            <select 
                                id="aspect"
                                value={aspect} 
                                onChange={onAspectChange}
                                className="ml-2 p-1 rounded-md"
                            >
                                {aspectRatios.map((ratio) => (
                                <option
                                    key={ratio.text}
                                    value={ratio.value}
                                >
                                    {ratio.text}
                                </option>
                                ))}
                            </select>
                        </div>
                        <div className="rounded-md bg-slate-200 p-2">
                            <label htmlFor="rotation">Rotation:</label>
                            <input
                                type="range"
                                id="rotation"
                                min={0}
                                max={360}
                                step={1}
                                className="ml-1 w-36 sm:w-52 align-middle"
                                value={rotation}
                                onChange={(e) => setRotation(e.target.value)}
                            />
                            <span id="rotation-value" className="ml-1 font-bold">
                                {rotation}
                            </span>
                        </div>
                        <div>
                            <button id="resizeButton"
                                className="ml-4 px-5 py-2 cursor-pointer rounded-md text-white bg-violet-600 hover:bg-violet-400"
                                onClick={cropImage}>
                                <CropIcon /> Crop
                            </button>
                        </div>
                    </div>
                    <div className="mt-5 rounded-md border-2 border-slate-200">
                        <div className="flex flex-wrap p-2 gap-2 items-center justify-center">
                            <div className="">
                                <label htmlFor="resizeWidth">Width:</label>
                                <input
                                    type="number"
                                    id="resizeWidth"
                                    placeholder="Width"
                                    className="ml-1 px-1 rounded-md w-20"
                                    value={width}
                                    onChange={(e) => setWidth(e.target.value)}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="resizeHeight">Height:</label>
                                <input
                                    type="number"
                                    id="resizeHeight"
                                    placeholder="Height"
                                    className="ml-1 px-1 rounded-md w-20"
                                    value={height}
                                    onChange={(e) => setHeight(e.target.value)}
                                />
                            </div>
                            <div 
                                className="border rounded-md p-1 cursor-pointer hover:text-sky-500"
                                onClick={() => {setWidth(420); setHeight(420)}}
                            >
                                420x420
                            </div>
                            <div 
                                className="border rounded-md p-1 cursor-pointer hover:text-sky-500"
                                onClick={() => {setWidth(640); setHeight(430)}}
                            >
                                640x430
                            </div>
                        </div>
                        <div className="flex flex-wrap p-2 gap-2 items-center justify-center">
                            <div className="">
                                <label htmlFor="resizePercentage">
                                    Percentage:
                                </label>
                                <input
                                    type="number"
                                    id="resizePercentage"
                                    placeholder="Percentage"
                                    className="ml-1 px-1 rounded-md w-20"
                                    value={percentage}
                                    onChange={(e) => handlePercentageChange(e.target.value)}
                                />
                            </div>
                            <div 
                                className="border rounded-md p-1 cursor-pointer hover:text-sky-500"
                                onClick={() => {handlePercentageChange(75)}}
                            >
                                75%
                            </div>
                            <div 
                                className="border rounded-md p-1 cursor-pointer hover:text-sky-500"
                                onClick={() => handlePercentageChange(50)}
                            >
                                50%
                            </div>
                            <div 
                                className="border rounded-md p-1 cursor-pointer hover:text-sky-500"
                                onClick={() => {handlePercentageChange(25)}}
                            >
                                25%
                            </div>
                            <div 
                                className="border rounded-md p-1 cursor-pointer hover:text-sky-500"
                                onClick={() => {handlePercentageChange(10)}}
                            >
                                10%
                            </div>
                        </div>
                        <div className="mb-5">
                            <label htmlFor="quality">Quality:</label>
                            <input
                                type="range"
                                id="quality"
                                min="1"
                                max="100"
                                className="ml-1 w-36 sm:w-52 align-middle"
                                value={quality}
                                onChange={(e) => setQuality(e.target.value)}
                            />
                            <span id="quality-value" className="ml-1 font-bold">
                                {quality}
                            </span>
                        </div>

                        <div className="flex flex-col sm:flex-row flex-wrap p-2 gap-2 items-center justify-center">
                            <button id="resizeButton"
                                className="px-5 py-2 cursor-pointer rounded-md text-white bg-green-500 hover:bg-green-700"
                                onClick={handleResizeAndCompress}>
                                Resize & Compress
                            </button>
                            {image && (
                                <div className="p-2 gap-2">
                                    <a
                                        id="downloadPNG"
                                        className="px-5 py-3 ml-2 cursor-pointer rounded-md text-white bg-sky-500 hover:bg-sky-700"
                                        href={image}
                                        download="compressed.png"
                                        onClick={(e) => handleDownload(e,'PNG')}
                                    >
                                        Download PNG
                                    </a>
                                    <a
                                        id="downloadJPG"
                                        className="px-5 py-3 ml-2 cursor-pointer rounded-md text-white bg-orange-500 hover:bg-orange-700"
                                        href={image}
                                        download="compressed.jpg"
                                        onClick={(e) => handleDownload(e,'JPG')}
                                    >
                                        Download JPG
                                    </a>

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
};

export default ImageResizer;
